import { type FC } from 'react';
import { RiAlertFill } from 'react-icons/ri';
import { _notNil } from '@/littledash.ts';

interface ErrorFilterLinkProps {
  errorCount: number;
  totalErrorCount?: number | null;
  onViewErrorsClick: (replace: boolean) => void;
  testId?: string;
}

const ErrorFilterLink: FC<ErrorFilterLinkProps> = ({
  errorCount,
  totalErrorCount = null,
  onViewErrorsClick,
  testId = 'view-errors-link',
}) => {
  const hasTotal = _notNil(totalErrorCount) && totalErrorCount !== errorCount;

  if (errorCount === 0 && !hasTotal) {
    return null;
  }

  return (
    <div className="flex items-center">
      <RiAlertFill className="red mr2" size={16} />
      <button className="link-button red" onClick={() => onViewErrorsClick(false)} data-testid={testId}>
        View {errorCount} error{errorCount === 1 ? '' : 's'}
      </button>
      {hasTotal && (
        <>
          <span className="dark-gray mh2" aria-hidden="true">
            &middot;
          </span>
          <button className="link-button red" onClick={() => onViewErrorsClick(true)} data-testid={`${testId}-total`}>
            View all {totalErrorCount}
          </button>
        </>
      )}
    </div>
  );
};

export default ErrorFilterLink;
